import React from "react";
import RequirementSection from "../components/RequirementSection";

const SectionA = () => <RequirementSection section="A" title='1' />;

export default SectionA;